import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnIL: CultureInfo = {
  name: 'en-IL',
  displayName: 'English (Israel)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-IL',
  parent: CultureInfoEn
};
